import { CableSnapModal } from '@ab-core/cablesnap';
import { AddToListsOrCartsModal } from '@ab-core/cartListModal';
import { ContactPersonModal } from '@ab-core/contact-person-modal';
import { isLoggedIn } from '@ab-core/hooks';
import { ItShopModal } from '@ab-core/it-shop-modal';
import { PriceCalculation } from '@ab-core/pricecalculation';
import { ProductRelationModal } from '@ab-core/product-relation-modal';
import { productStore } from '@ab-core/store';
import type { FC } from 'react';
import React from 'react';

type ProductModalProps = { primaryButtonClicked?: () => void };

export const ProductModal: FC<ProductModalProps> = (props) => {
    const { primaryButtonClicked } = props;
    const openContactPerson = productStore.getters.useShowContactPersonModal();
    const openItShop = productStore.getters.useShowItShopModal();
    const openSuccessorModal = productStore.getters.useShowSuccessorModal();
    const successorSku = productStore.getters.useSuccessorSku();
    const isUserLoggedIn = isLoggedIn();
    const openCalculator = productStore.getters.useShowCalculator();
    const openCableSnap = productStore.getters.useShowCableSnap();
    const product = productStore.getters.useProduct();
    const positionPriceObject = productStore.getters.usePrice();

    const showCartOrShoppingList = productStore.getters.useShowCartOrShoppingListModal();
    const quantity = productStore.getters.useQuantity();
    const closeContactPerson = () => productStore.setters.setShowContactPersonModal(false);
    const closeItShop = () => {
        productStore.setters.setShowItShopModal(false);
        productStore.setters.setProduct(undefined);
    };
    const closeCalculator = () => productStore.setters.setShowCalculator(false);
    const closeCartList = () => productStore.setters.setShowCartOrShoppingListModal(false);
    const closeSuccessorModal = () => {
        productStore.setters.setShowSuccessorModal(false);
        productStore.setters.setSuccessorSku('');
        productStore.setters.setProduct(undefined);
    };
    const closeCableSnapModal = () => {
        productStore.setters.setShowCableSnap(false);
    };

    return (
        <>
            {isUserLoggedIn && (
                <>
                    <ContactPersonModal {...product} open={openContactPerson} onClose={closeContactPerson} />
                    <ItShopModal {...product} open={openItShop} onClose={closeItShop} ean={product?.ean} />
                    <PriceCalculation
                        {...product}
                        open={openCalculator}
                        onClose={closeCalculator}
                        positionPriceObject={positionPriceObject}
                        quantity={quantity}
                    />
                    <CableSnapModal open={openCableSnap} onClose={closeCableSnapModal} />
                    <AddToListsOrCartsModal
                        primaryButtonClicked={primaryButtonClicked}
                        open={showCartOrShoppingList}
                        onClose={closeCartList}
                    />
                    <ProductRelationModal
                        {...product}
                        primaryButtonClicked={primaryButtonClicked}
                        open={openSuccessorModal}
                        onClose={closeSuccessorModal}
                        successorProduct={successorSku}
                        quantity={quantity}
                    />
                </>
            )}
        </>
    );
};
